import { esc } from "./stars";

const PLACEHOLDER_SVG = `<svg viewBox="0 0 60 90" xmlns="http://www.w3.org/2000/svg">
  <rect x="4" y="4" width="52" height="82" rx="4" fill="#1a1a2e" stroke="#ff9900" stroke-width="2"/>
  <line x1="16" y1="4" x2="16" y2="86" stroke="#ff9900" stroke-width="2" opacity="0.5"/>
  <rect x="22" y="20" width="28" height="3" rx="1" fill="#ff9900" opacity="0.5"/>
  <rect x="22" y="28" width="20" height="3" rx="1" fill="#ff9900" opacity="0.3"/>
  <rect x="22" y="36" width="24" height="3" rx="1" fill="#ff9900" opacity="0.3"/>
</svg>`;

function getPlaceholderHtml(size: "small" | "large"): string {
  return `<div class="cover-image cover-image--${size}"><div class="cover-placeholder">${PLACEHOLDER_SVG}</div></div>`;
}

function escapeForAttr(html: string): string {
  return html
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function renderCoverImage(
  coverUrl: string | undefined,
  size: "small" | "large",
): string {
  if (!coverUrl) return renderCoverPlaceholder(size);

  const fallback = escapeForAttr(getPlaceholderHtml(size));
  return `<div class="cover-image cover-image--${size}"><img src="${esc(coverUrl)}" alt="Book cover" class="cover-image__img" onerror="this.parentElement.innerHTML='${fallback}'"/></div>`;
}

export function renderCoverPlaceholder(size: "small" | "large"): string {
  return getPlaceholderHtml(size);
}
